import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Submit from '@shared/forms/Submit'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { T } from '@transifex/react'
import { ReactNode } from 'react'
import { UseFormReturn } from 'react-hook-form'
import useMobileRecognitionDrawer, {
  MobileRecognitionDrawerView,
} from './useMobileRecognitionDrawer'

const useMobileRecognitionViewActions = (
  form: UseFormReturn<RecognitionFormData>,
  handleSaveAsDraft: () => void,
  isPendingCreateOrSave: boolean,
  showDraftButton: boolean,
): Record<MobileRecognitionDrawerView, ReactNode | undefined> => {
  const { setView, closeDrawer } = useMobileRecognitionDrawer()
  const scheduledAt = form.watch('scheduledAt')
  const isScheduledSend = !!scheduledAt

  const onSaveAsDraft = () => {
    handleSaveAsDraft()
    closeDrawer()
  }

  return {
    [MobileRecognitionDrawerView.DRAFT_AND_SCHEDULED]: (
      <Button
        fullWidth
        id="btnStartNewRecognition"
        variant="contained"
        color="primary"
        onClick={() => setView(MobileRecognitionDrawerView.RECIPIENTS)}>
        <T _str="Start new recognition" />
      </Button>
    ),
    [MobileRecognitionDrawerView.RECIPIENTS]: (
      <Button
        fullWidth
        id="btnNext"
        variant="contained"
        color="primary"
        onClick={async () => {
          const isValid = await form.trigger('sendTo')
          if (isValid) {
            setView(MobileRecognitionDrawerView.SEND)
          }
        }}>
        <T _str="Next" />
      </Button>
    ),
    [MobileRecognitionDrawerView.SEND]: (
      <Stack width="100%" spacing={1.5}>
        <Submit
          elementId="btnSendRecognition"
          formState={form.formState}
          fullWidth
          disabled={isPendingCreateOrSave}
          submitText={isScheduledSend ? <T _str="Schedule" /> : <T _str="Send" />}
        />
        {showDraftButton && (
          <Button
            fullWidth
            color="primary"
            id="btnSaveRecognitionAsDraft"
            variant="text"
            disabled={isPendingCreateOrSave}
            onClick={onSaveAsDraft}>
            <T _str="Save as draft" />
          </Button>
        )}
      </Stack>
    ),
    [MobileRecognitionDrawerView.VISIBILITY]: undefined,
    [MobileRecognitionDrawerView.QUALITIES]: undefined,
    [MobileRecognitionDrawerView.POINTS]: undefined,
    [MobileRecognitionDrawerView.SCHEDULE]: undefined,
    [MobileRecognitionDrawerView.POINTS_EXCEPTION]: undefined,
  }
}

export default useMobileRecognitionViewActions
